import { GLOBAL_OBJ } from '@sentry/utils';

const WINDOW = GLOBAL_OBJ

;

export { WINDOW };
//# sourceMappingURL=types.js.map



// WEBPACK FOOTER //
// ./~/@sentry-internal/tracing/esm/browser/types.js